import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "./select";
import { cn } from "../../lib/utils";

export default function SelectFilter({ 
  label, 
  value, 
  onChange, 
  options = [], 
  placeholder, 
  className,
  triggerClassName,
  searchable = false,
  onClear
}) {
  const [searchTerm, setSearchTerm] = useState('');
  
  const selectedOption = options.find(opt => opt.value === value);
  const displayValue = selectedOption ? selectedOption.label : (placeholder || 'Select');

  const filteredOptions = searchable 
    ? options.filter(opt => opt.label.toLowerCase().includes(searchTerm.toLowerCase()))
    : options;

  return (
    <div className={cn("inline-flex items-center", className)}>
      <Select 
        value={value || ""} 
        onValueChange={(val) => {
          if (val === "___clear___") {
            if (onClear) onClear();
          } else {
            onChange(val);
          }
          setSearchTerm('');
        }}
      >
        <SelectTrigger className={cn(
          "h-8 w-auto border-none bg-transparent hover:bg-muted/50 px-2.5 py-1 transition-colors gap-1.5 focus:ring-0 focus:ring-offset-0 shadow-none group",
          triggerClassName
        )}>
          <div className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest whitespace-nowrap">
            <span className="text-muted-foreground/60">{label}</span>
            <span className="text-foreground">{displayValue}</span>
          </div>
        </SelectTrigger>
        <SelectContent className="bg-card border-border shadow-xl min-w-[200px] z-[300] rounded-xl overflow-hidden p-1 flex flex-col gap-1">
          {searchable && (
            <div className="px-2 py-1.5 border-b border-border/50 mb-1 flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
              <Search className="w-3 h-3 text-muted-foreground/50" />
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="bg-transparent border-none focus:outline-none text-[10px] font-bold uppercase tracking-widest w-full placeholder:text-muted-foreground/30"
                onKeyDown={(e) => e.stopPropagation()}
              />
            </div>
          )}
          
          <div className="max-h-[240px] overflow-y-auto custom-scrollbar">
            {onClear && value && (
              <SelectItem 
                value="___clear___" 
                className="text-[10px] font-black uppercase tracking-widest cursor-pointer py-2 rounded-lg hover:bg-destructive/10 hover:text-destructive transition-colors pl-8 pr-2 mb-1 border-b border-border/30"
              >
                <div className="flex items-center gap-2">
                  <X className="w-3 h-3" />
                  Clear Filter
                </div>
              </SelectItem>
            )}
            
            {filteredOptions.length === 0 ? (
              <div className="px-8 py-4 text-[10px] font-bold text-muted-foreground/50 uppercase tracking-widest italic text-center">
                No results found
              </div>
            ) : (
              filteredOptions.map((opt) => (
                <SelectItem 
                  key={opt.value} 
                  value={opt.value} 
                  className="text-[10px] font-black uppercase tracking-widest cursor-pointer py-2 rounded-lg hover:bg-muted transition-colors pl-8 pr-2"
                >
                  {opt.label}
                </SelectItem>
              ))
            )}
          </div>
        </SelectContent>
      </Select>
    </div>
  );
}
